import { isDOM } from '@app/shared/predicates'
import { identifyStatusPageIncident } from './appcues-status-page'
import { setupAppcuesErrorMonitoring } from './appcues-error-monitoring'

function trackVisit(): void {
  if (!window.analytics) {
    return
  }

  void window.analytics.page(document.title, {
    path: window.location.pathname,
    host: window.location.host,
  })
}

function reloadAppcuesThroughSegment(): void {
  window.onDomLoad(($dom) => {
    if (isDOM($dom[0])) {
      trackVisit()
    }
  })
}

export default function setupAppcuesThroughSegment(): () => void {
  window.eventHub.$on('appcues-through-segment:loaded', () => {
    trackVisit()
    setupAppcuesErrorMonitoring()
    void identifyStatusPageIncident()
  })

  reloadAppcuesThroughSegment()

  return reloadAppcuesThroughSegment
}
